module.exports = __webpack_public_path__ + "static/media/Facebook.2ce9d35f.svg";